import {
  convertQueryCommandToQueryString,
  Equal,
  IQueryCommandOptions,
} from '@llws/dynamic-router-utils';
import { ITourUtmTracking } from '@llws/lift-entity-interfaces';
import vm from '@/main';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import { adminRequest } from '@/shared/request-configs/admin-request';

const agentGatewayResourcePath = '/tour-api-agent/tour_utm_tracking';
const adminGatewayResourcePath = '/tour-api-admin/tour_utm_tracking';

interface IUtmTrackingState extends IStateStrict<ITourUtmTracking> {
  enabledSourceNames: string[];
}

const base = new StoreBaseImplementation<ITourUtmTracking>({
  adminGatewayResourcePath,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
    enabledSourceNames: [] as string[],
  },

  getters: {
    ...base.getters,
    visibleList: (state: IStateStrict<ITourUtmTracking>): ITourUtmTracking[] => (
      (state.list?.data ?? []).filter((source) => source.status !== 'deleted')
    ),

    enabledSourceNames: (state: IUtmTrackingState): string[] => state.enabledSourceNames,
  },

  mutations: {
    ...base.mutations,
    setEnabledSourceNames: (state: IUtmTrackingState, payload: string[]): void => {
      state.enabledSourceNames = payload;
    },
  },

  actions: {
    ...base.actions,

    /**
     * Fetches the distinct source names from every enabled UTM tracking source across the
     * client's properties (not just one building's), for use as filter options - e.g. the Tours
     * List Source filter.
     */
    getEnabledSourceNames: async (ctx: IAction<IUtmTrackingState>): Promise<void> => {
      const resourcePath = vm()?.$rsGlobals.$hasToursRestricted() ? agentGatewayResourcePath : adminGatewayResourcePath;
      const filters: IQueryCommandOptions = {
        selectDistinct: 'source',
        where: [Equal('status', 'enabled')],
      };
      const response = await adminRequest.get<Pick<ITourUtmTracking, 'source'>[]>(
        `${resourcePath}${convertQueryCommandToQueryString(filters)}`,
      );
      ctx.commit('setEnabledSourceNames', (response.data ?? []).map((row) => row.source));
    },
  },
};
